export default __webpack_public_path__ + "static/mobilebanner-ff3147c7ef12ab3e5485c43a2cd24866.png";